import React from 'react';
import { AnimationWrapper } from '../animations';
import { SectionBackground } from '../SectionBackground';
import { getContentContainerProps } from '../sections/contentLayout';
import type { SectionBaseConfig } from '../../../storefront-schema/types';

interface SectionShellProps {
  config?: SectionBaseConfig;
  className?: string;
  children: React.ReactNode;
  containerMaxWidth?: number;
  fullBleed?: boolean;
}

export const SectionShell: React.FC<SectionShellProps> = ({
  config,
  className = '',
  children,
  containerMaxWidth = 1152,
  fullBleed = false,
}) => {
  const backgroundImage = config?.backgroundImage;
  const backgroundBlendMode = config?.backgroundBlendMode || 'normal';
  const containerProps = fullBleed
    ? { className: 'w-full', style: {} as React.CSSProperties }
    : getContentContainerProps(config, containerMaxWidth, 'container relative');

  return (
    <section
      className={`relative py-[clamp(48px,9vw,112px)] -mx-4 px-4 overflow-hidden ${backgroundImage ? 'section-bg-flow' : ''} ${className}`}
      style={
        {
          backgroundColor: config?.colors?.background || 'transparent',
          backgroundImage: config?.colors?.backgroundGradient || undefined,
          '--glass-bg': config?.colors?.background,
          '--color-text': config?.colors?.text,
          '--header-text-color': config?.colors?.text,
          '--primary-color': config?.colors?.primary,
        } as React.CSSProperties
      }
    >
      <SectionBackground config={config as any} />
      {backgroundImage && (
        <>
          <img
            src={backgroundImage}
            alt=""
            aria-hidden="true"
            className="section-bg-img md:hidden block w-full h-auto pointer-events-none relative z-0"
            style={{ mixBlendMode: backgroundBlendMode as any }}
          />
          <div
            className="hidden md:block absolute inset-0 bg-cover bg-center z-0"
            style={{
              backgroundImage: `url(${backgroundImage})`,
              mixBlendMode: backgroundBlendMode as any,
            }}
          />
        </>
      )}
      <AnimationWrapper enabled={config?.animations?.enableEntrance === true}>
        <div className={`${containerProps.className} ${backgroundImage ? 'section-bg-overlay' : ''}`} style={containerProps.style}>
          {children}
        </div>
      </AnimationWrapper>
    </section>
  );
};
